export const LocationIcon = () => {
  return (
    <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
      <g id="system-uicons:location">
        <g id="Group">
          <path
            clipRule="evenodd"
            d="M9.99993 17.6571L10.6009 16.9799C11.2828 16.199 11.8961 15.458 12.4418 14.7532L12.8923 14.159C14.7733 11.6247 15.7142 9.61324 15.7142 8.12657C15.7142 4.95324 13.1561 2.38086 9.99993 2.38086C6.84374 2.38086 4.28564 4.95324 4.28564 8.12657C4.28564 9.61324 5.2266 11.6247 7.10755 14.159L7.55803 14.7532C8.33654 15.7508 9.15104 16.7187 9.99993 17.6571Z"
            fillRule="evenodd"
            id="Vector"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.99985 10.476C11.3148 10.476 12.3808 9.41003 12.3808 8.09506C12.3808 6.7801 11.3148 5.71411 9.99985 5.71411C8.68489 5.71411 7.6189 6.7801 7.6189 8.09506C7.6189 9.41003 8.68489 10.476 9.99985 10.476Z"
            id="Vector_2"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};
